import React, { memo } from 'react';

export const LoadingIndicator = memo(() => {
  return (
    <div className="flex justify-start">
      <div className="bg-muted max-w-[80%] border border-gray-200 dark:border-gray-700 p-4 rounded-2xl text-grey-600 dark:text-white">
        <div className="flex items-center space-x-2">
          <div className="flex space-x-1">
            <div className="w-2 h-2 bg-gray-400 rounded-full animate-bounce"></div>
            <div 
              className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" 
              style={{animationDelay: '0.1s'}}
            ></div>
            <div 
              className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" 
              style={{animationDelay: '0.2s'}}
            ></div>
          </div>
          <span className="text-sm">Thinking...</span>
        </div>
      </div>
    </div>
  );
});